import { Box } from '@mui/material';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MaterialAutocompleteField } from '@/shared/components/forms';
import { SearchFilters } from '../types/search.types';

interface ProductFilterProps {
  readonly control: Control<SearchFilters>;
}

export function ProductFilter({ control }: Readonly<ProductFilterProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <MaterialAutocompleteField
        categoryName="materialCategory"
        subcategoryName="materialSubcategory"
        materialIdName="materialId"
        control={control}
        categoryLabel={t('search.product.categoryLabel')}
        subcategoryLabel={t('search.product.subcategoryLabel')}
        categoryPlaceholder={t('search.product.categoryPlaceholder')}
        subcategoryPlaceholder={t('search.product.subcategoryPlaceholder')}
        categoryId="material-category-filter"
        subcategoryId="material-subcategory-filter"
        categoryAriaLabel={t('search.product.categoryLabel')}
        subcategoryAriaLabel={t('search.product.subcategoryLabel')}
      />
    </Box>
  );
}
